import { gql } from '@apollo/client';
import '@cobliteam/common-types';
import type { CreateCheckpointManualInput, CreateManualOdometerResponse } from '../../__generated__/graphql';
import graphQLRequester from '../../request/GraphQLRequester';
import type { GraphQLRestDataSourceError } from '../../request/Types';

export class GraphQLOdometerRequester {
  public createCheckpointManual = (input: CreateCheckpointManualInput): Promise<CreateManualOdometerResponse> =>
    graphQLRequester
      .mutate<{ createCheckpointManual: CreateManualOdometerResponse; errors?: GraphQLRestDataSourceError[] }, { input: CreateCheckpointManualInput }>({
        mutation: gql`
          mutation createCheckpointManual($input: CreateCheckpointManualInput!) {
            createCheckpointManual(input: $input) {
              manualOdometer {
                id
                odometerAt
                odometerInKms
                createdBy
                createdAt
              }
              vehicle {
                id
                licensePlate
              }
            }
          }
        `,
        variables: { input },
      })
      .then((result) => {
        if (result.errors?.length) {
          throw result.errors[0];
        }
        return result.createCheckpointManual;
      });
}

export default GraphQLOdometerRequester;
